<template>
  <div :class="classes">
    <span v-if="total" class="cart__total">
      {{ totalText }}: <span class="cart__total__text">{{ total }}</span>
    </span>
    <m4-button
      tag="a"
      variant="default-text"
      :href="link && items ? link : null"
      :title="link && items ? infoText : infoEmptyText"
    >
      <span v-if="items > 0" class="cart__counter">
        <em>{{ items }}</em>
      </span>
      <m4-icon icon="cart" class="cart__icon"></m4-icon>
    </m4-button>
  </div>
</template>

<script>
export default {
  name: "M4Cart",
  props: {
    items: [String, Number],
    link: String,
    total: String,
    totalText: {
      type: String,
      default: "TOTAL"
    },
    size: {
      type: String,
      default: "sm"
    },
    infoText: {
      type: String,
      default: "Go to the cart summary"
    },
    infoEmptyText: {
      type: String,
      default: "Cart is empty"
    }
  },
  computed: {
    classes() {
      let classes = ["cart"];
      classes.push("cart--" + this.size);
      if (this.items) {
        classes.push("cart--has-items");
      }
      return classes;
    }
  }
};
</script>
